// components/shared/sectors/SectorsList.tsx
import {  Sector } from "@cabukaka/types";
import {  SectorCard } from "./SectorCard";

interface SectorsListProps {
  sectors: Sector[];
}

export function SectorsList({ sectors }: SectorsListProps) {
  return (
    <div className="space-y-6 md:space-y-8">
      {sectors.map((sector) => (
        <SectorCard
          key={sector.id}
          sector={sector}
        />
      ))}
    </div>
  );
}